<ng-template let-errors="errors" #globalForm>
    <ng-container>
        <form [formGroup]="form">
            <div style="margin: 5px 5px">
                <div class="w100 flex-direction-row flex-start-stretch">
                    <mat-card style="margin: 5px 5px 5px 0" class="box-name">
                        <mat-card-content>
                            <mat-form-field class="w100">
                                <mat-label>{{ 'SensorEvent.name'|translate }}</mat-label>
                                <input matInput formControlName="name">
                            </mat-form-field>
                            <mat-error
                                    *ngIf="errors!=null&&errors['name']">{{ ('errorsForm.' + errors['name'])|translate }}
                            </mat-error>
                            <div class="box-type">
                                <mat-label style="margin: 0 10px 0 0"
                                           class="color-contrast-theme">
                                    {{ 'SensorEvent.type'|translate }}
                                </mat-label>

                                <mat-button-toggle-group formControlName="type" [hideSingleSelectionIndicator]="true">
                                    <ng-container
                                            *ngFor="let pValue of sensorEventType|transformValueByPredicateFunction:predicateSensoEventEnum">
                                        <mat-button-toggle [value]="pValue.valueForm"
                                                           *ngIf="pValue|transformValueByPredicateFunction:getIconTypePredicate as typeIcon ">
                                            <ng-container *ngIf="typeIcon.icon;else SVGICON">
                                                <mat-icon [matTooltip]="typeIcon.tooltipText|translate"
                                                          class="icon-size-small_medium">{{ typeIcon.icon }}
                                                </mat-icon>
                                            </ng-container>
                                            <ng-template #SVGICON>
                                                <mat-icon [matTooltip]="typeIcon.tooltipText|translate"
                                                          svgIcon="{{typeIcon.svgIcon}}"
                                                          class="icon-size-small_medium"></mat-icon>
                                            </ng-template>
                                        </mat-button-toggle>
                                    </ng-container>
                                </mat-button-toggle-group>
                                <mat-error
                                        *ngIf="errors!=null&&errors['type']">{{ ('errorsForm.' + errors['type'])|translate }}
                                </mat-error>
                                <mat-divider style="margin-top: 10px"></mat-divider>
                            </div>
                            <div class="box-type">
                                <mat-checkbox
                                        formControlName="repeatEvent">{{ 'SensorEvent.repeatEvent'|translate }}
                                </mat-checkbox>
                                <mat-error
                                        *ngIf="errors!=null&&errors['repeatEvent']">{{ ('errorsForm.' + errors['repeatEvent'])|translate }}
                                </mat-error>
                            </div>
                        </mat-card-content>

                    </mat-card>
                    <mat-card style="margin: 5px 0 5px 5px" class="box-note">
                        <mat-card-content>

                            <mat-form-field class="w100">
                                <mat-label>{{ 'SensorEvent.note'|translate }}</mat-label>
                                <textarea matInput formControlName="note"
                                          cdkTextareaAutosize
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="8"
                                ></textarea>
                            </mat-form-field>
                            <mat-error
                                    *ngIf="errors!=null&&errors['note']">{{ ('errorsForm.' + errors['note'])|translate }}
                            </mat-error>
                            <mat-label style="margin: 0 10px 0 0"
                                       class="color-contrast-theme visualized-in-desktop">{{ 'SensorEvent.modality.title'|translate }}
                            </mat-label>
                            <app-floating-buttons
                                    title="{{ 'SensorEvent.modality.title'|translate }}"
                                    mode="other"
                                    formControlName="modalityNotification"
                                    [possibleValues]="possibleValuesSensorEventModalityNotificationType"
                            >
                            </app-floating-buttons>
                            <mat-form-field style="width: 100%; margin-top: 10px;">
                                <mat-label>{{ 'SensorEvent.hysteresis'|translate }}</mat-label>
                                <input matInput type="number" formControlName="hysteresis">
                                <button mat-icon-button matSuffix [matTooltip]="'SensorEvent.hysteresisInfo'|translate">
                                    <mat-icon>info</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-error
                                    *ngIf="errors!=null&&errors['hysteresis']">{{ ('errorsForm.' + errors['hysteresis'])|translate }}
                            </mat-error>
                            <mat-form-field style="width: 100%;">
                                <mat-label>{{ 'SensorEvent.deactivationHysteresis'|translate }}</mat-label>
                                <input matInput type="number" formControlName="deactivationHysteresis">
                                 <button mat-icon-button matSuffix [matTooltip]="'SensorEvent.deactivationHysteresisInfo'|translate">
                                    <mat-icon>info</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-error
                                    *ngIf="errors!=null&&errors['deactivationHysteresis']">{{ ('errorsForm.' + errors['deactivationHysteresis'])|translate }}
                            </mat-error>

                        </mat-card-content>
                    </mat-card>
                    <ng-container>
                        <mat-card style="max-width: 100%;width: 100%">
                            <mat-card-header>
                                <mat-card-subtitle>
                                    {{ 'SensorEvent.email'|translate }}
                                </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-subtitle>
                                <mat-error
                                        *ngIf="errors!=null&&errors['notification']">{{ ('errorsForm.' + errors['notification'])|translate }}
                                </mat-error>
                            </mat-card-subtitle>
                            <mat-card-content>
                                <div class="flex-between-center">
                                    <mat-checkbox formControlName="sendSms">{{ 'SensorEvent.sendSms'|translate }}
                                    </mat-checkbox>
                                    <app-multi-select-form-field *ngIf="data.users"
                                                                 formControlName="notificationUsers"
                                                                 [multiple]="true"
                                                                 labelSearch="{{ 'SensorEvent.notificationUsers'|translate }}"
                                                                 [possibleValues]="data.users|transformValueByPredicateFunction:getPossibleValuesUsersPredicate"
                                    >

                                    </app-multi-select-form-field>
                                </div>
                                <div formGroupName="notification">
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>{{ 'SensorEvent.subject'|translate }}</mat-label>
                                        <input matInput formControlName="subject">
                                    </mat-form-field>
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>{{ 'SensorEvent.body'|translate }}</mat-label>
                                        <textarea matInput
                                                  cdkTextareaAutosize
                                                  cdkAutosizeMinRows="3"
                                                  cdkAutosizeMaxRows="6"
                                                  formControlName="body"
                                        ></textarea>
                                    </mat-form-field>
                                </div>

                            </mat-card-content>
                        </mat-card>
                    </ng-container>
                </div>
            </div>
        </form>
    </ng-container>
    <div class="w100 margin-5px flex-center-center" style="margin-top: 10px">
        <mat-card>
            <mat-card-content class="color-contrast-theme card-title">
                <mat-card-title>
                    {{ 'SensorEvent.enablingStatements'|translate }}
                </mat-card-title>
                <mat-card-subtitle>
                    <mat-error
                            *ngIf="errors!=null&&errors['enablingStatements']">{{ ('errorsForm.' + errors['enablingStatements'])|translate }}
                    </mat-error>
                </mat-card-subtitle>
            </mat-card-content>
        </mat-card>
    </div>
    <mat-card class="margin-5px">
        <mat-card-content>
            <ng-container *ngIf="(enablingStatements$|async) as statementsOr;else NoEnablingStatements">
                <div style="padding: 10px" class="w100 flex-center-center">
                    <button mat-raised-button style="margin: 5px 0;height: unset"
                            (click)="clickAddEnablingStatementOr(statementsOr)"
                            color="primary"
                            [disabled]="(statementsOr|transformValueByPredicateFunction:predicateDisableAddOrButton)||!isEditable">
                        <mat-icon svgIcon="or" class="icon-size-medium"></mat-icon>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <ng-container *ngFor="let statementsAnd of statementsOr; let lastOr=last;let indexOr=index">
                    <mat-card class="background-default-select-important">
                        <mat-card-header>
                            <button [disabled]="statementsOr|transformValueByPredicateFunction:predicateDisableRemoveOrButton"
                                    mat-icon-button
                                    color="accent"
                                    mat-card-avatar
                                    (click)="$event.stopPropagation();clickRemoveEnablingStatementOr(statementsOr,indexOr)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-chip-listbox>
                                @if (isEditable) {
                                    <mat-chip (click)="clickAddEnablingStatementAnd(statementsOr,indexOr)">
                                        <mat-icon color="accent">add</mat-icon>
                                        <mat-icon svgIcon="and"></mat-icon>
                                    </mat-chip>
                                }
                                <ng-container
                                        *ngFor="let statement of statementsAnd;let lastAnd=last;let indexAnd=index">
                                    <ng-container
                                            *ngIf="(statement|transformValueByPredicateFunction:predicateGetAndChips:elements:calendars) as chipValues">
                                        <mat-chip class="chip-statement"
                                                  (click)="clickEnablingStatementAnd(statementsOr,indexOr,indexAnd)">
                                            <mat-icon matChipRemove
                                                      (click)="$event.stopPropagation();clickRemoveEnablingStatementAnd(statementsOr,indexOr,indexAnd)">
                                                cancel
                                            </mat-icon>
                                            <div class="flex-center-center bold">
                                                <span class="chip-title"
                                                      *ngIf="chipValues.sx.sensorName || chipValues.sx.type">
                                                    {{ chipValues.sx.sensorName }}
                                                    {{ (chipValues.sx.type ?? '') | translate }}
                                                </span>
                                                <span *ngIf="chipValues.sx.op">
                                                    {{ chipValues.sx.op | translate }}
                                                </span>
                                                <span *ngIf="chipValues.sx.infoNameTraduction">{{ ((chipValues.sx.infoNameTraduction!|sensorDataTraduction$)|async) }}</span>
                                                <mat-icon *ngIf="chipValues.operator" [svgIcon]="chipValues.operator"
                                                          style="margin: 0 5px">
                                                </mat-icon>

                                                <span *ngIf="chipValues.dx.value!=null;else DEVICE">
                                                    <ng-container>{{ chipValues.dx.value|traductionNotTraduction|async }}</ng-container>
                                                </span>
                                                <ng-template #DEVICE>

                                                 <span *ngIf="chipValues.dx.sensorName"
                                                       style="border-right: 1px solid;padding-right: 5px;margin-right: 5px;">
                                                {{ chipValues.dx.sensorName }}
                                                 </span>
                                                    <span *ngIf="chipValues.dx.infoNameTraduction">{{ (chipValues.dx.infoNameTraduction!|translate) }}</span>

                                                </ng-template>
                                            </div>
                                        </mat-chip>
                                    </ng-container>
                                    <ng-container *ngIf="!lastAnd">
                                        <mat-icon svgIcon="and" class="icon-size-medium"></mat-icon>
                                    </ng-container>
                                </ng-container>
                            </mat-chip-listbox>
                        </mat-card-content>
                    </mat-card>
                    <div style="padding: 10px" class="w100 flex-center-center">
                        <mat-icon svgIcon="or" *ngIf="!lastOr" class="icon-size-medium"></mat-icon>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #NoEnablingStatements>
                <div style="padding: 10px" class="w100 flex-center-center">
                    <button mat-raised-button style="margin: 5px 0"
                            [disabled]="!isEditable"
                            (click)="clickAddEnablingStatementOr([])" color="primary">
                        <mat-icon>add</mat-icon>
                        <mat-icon svgIcon="or" class="icon-size-medium"></mat-icon>
                    </button>
                </div>
            </ng-template>
        </mat-card-content>
    </mat-card>
    <div class="w100 margin-5px flex-center-center" style="margin-top: 10px">
        <mat-card>
            <mat-card-content class="color-contrast-theme card-title">
                <mat-card-title>
                    {{ 'SensorEvent.statements'|translate }}
                </mat-card-title>
                <mat-card-subtitle>
                    <mat-error
                            *ngIf="errors!=null&&errors['statements']">{{ ('errorsForm.' + errors['statements'])|translate }}
                    </mat-error>
                </mat-card-subtitle>
            </mat-card-content>
        </mat-card>
    </div>
    <mat-card class="margin-5px">
        <mat-card-content>
            <ng-container *ngIf="(statements$|async) as statementsOr;else NoStatements">
                <div style="padding: 10px" class="w100 flex-center-center">
                    <button mat-raised-button style="margin: 5px 0;height: unset"
                            (click)="clickAddStatementOr(statementsOr)"
                            color="primary"
                            [disabled]="(statementsOr|transformValueByPredicateFunction:predicateDisableAddOrButton)||!isEditable">
                        <mat-icon svgIcon="or" class="icon-size-medium"></mat-icon>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <ng-container *ngFor="let statementsAnd of statementsOr; let lastOr=last;let indexOr=index">
                    <mat-card class="background-default-select-important">
                        <mat-card-header>
                            <button [disabled]="statementsOr|transformValueByPredicateFunction:predicateDisableRemoveOrButton"
                                    mat-icon-button
                                    color="accent"
                                    mat-card-avatar
                                    (click)="$event.stopPropagation();clickRemoveStatementOr(statementsOr,indexOr)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-card-header>
                        <mat-card-content>
                            <mat-chip-listbox>
                                @if (isEditable) {
                                    <mat-chip (click)="clickAddStatementAnd(statementsOr,indexOr)">
                                        <mat-icon color="accent">add</mat-icon>
                                        <mat-icon svgIcon="and"></mat-icon>
                                    </mat-chip>
                                }
                                <ng-container
                                        *ngFor="let statement of statementsAnd;let lastAnd=last;let indexAnd=index">
                                    <ng-container
                                            *ngIf="(statement|transformValueByPredicateFunction:predicateGetAndChips:elements:calendars) as chipValues">
                                        <mat-chip class="chip-statement"
                                                  (click)="clickStatementAnd(statementsOr,indexOr,indexAnd)">
                                            <mat-icon matChipRemove
                                                      (click)="$event.stopPropagation();clickRemoveStatementAnd(statementsOr,indexOr,indexAnd)">
                                                cancel
                                            </mat-icon>
                                            <div class="flex-center-center bold">
                                                <span class="chip-title"
                                                      *ngIf="chipValues.sx.sensorName || chipValues.sx.type">
                                                    {{ chipValues.sx.sensorName }}
                                                    {{ (chipValues.sx.type ?? '') | translate }}
                                                </span>
                                                <span *ngIf="chipValues.sx.op">
                                                    {{ chipValues.sx.op | translate }}
                                                </span>
                                                <span *ngIf="chipValues.sx.infoNameTraduction">{{ ((chipValues.sx.infoNameTraduction!|sensorDataTraduction$)|async) }}</span>
                                                <mat-icon *ngIf="chipValues.operator" [svgIcon]="chipValues.operator"
                                                          style="margin: 0 5px">
                                                </mat-icon>

                                                <span *ngIf="chipValues.dx.value!=null;else DEVICE">
                                                    <ng-container>{{ chipValues.dx.value|traductionNotTraduction|async }}</ng-container>
                                                </span>
                                                <ng-template #DEVICE>

                                                 <span *ngIf="chipValues.dx.sensorName"
                                                       style="border-right: 1px solid;padding-right: 5px;margin-right: 5px;">
                                                {{ chipValues.dx.sensorName }}
                                                 </span>
                                                    <span *ngIf="chipValues.dx.infoNameTraduction">{{ (chipValues.dx.infoNameTraduction!|translate) }}</span>

                                                </ng-template>
                                            </div>
                                        </mat-chip>
                                    </ng-container>
                                    <ng-container *ngIf="!lastAnd">
                                        <mat-icon svgIcon="and" class="icon-size-medium"></mat-icon>
                                    </ng-container>
                                </ng-container>
                            </mat-chip-listbox>
                        </mat-card-content>
                    </mat-card>
                    <div style="padding: 10px" class="w100 flex-center-center">
                        <mat-icon svgIcon="or" *ngIf="!lastOr" class="icon-size-medium"></mat-icon>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #NoStatements>
                <div style="padding: 10px" class="w100 flex-center-center">
                    <button mat-raised-button style="margin: 5px 0"
                            [disabled]="!isEditable"
                            (click)="clickAddStatementOr([])" color="primary">
                        <mat-icon>add</mat-icon>
                        <mat-icon svgIcon="or" class="icon-size-medium"></mat-icon>
                    </button>
                </div>
            </ng-template>

        </mat-card-content>
    </mat-card>
    <div class="w100 margin-5px flex-center-center" style="margin-top: 10px">
        <mat-card>
            <mat-card-content class="color-contrast-theme card-title">
                <mat-card-title>
                    {{ 'SensorEvent.actuators'|translate }}
                </mat-card-title>
            </mat-card-content>
        </mat-card>
    </div>
    <app-split-screen [breakPoint]="breakPoints">
        <div sx class="h100">
            <mat-card class="container-actuators margin-left-right-5px">
                <mat-card-header>
                    <mat-card-title class="color-contrast-theme">
                        {{ 'SensorEvent.infoActuators'|translate }}
                        <span class="color_green">{{ 'SensorEvent.verified'|translate }}</span>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <mat-error
                                *ngIf="errors!=null&&errors['actuators']">{{ ('errorsForm.' + errors['actuators'])|translate }}
                        </mat-error>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    @if (isEditable) {
                        <button style="margin: 5px 13px"
                                mat-raised-button color="primary" (click)="addActuators()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    }
                    <div class="flex-start-stretch flex-direction-row">
                        <mat-accordion class="example-headers-align width-panel" multi>
                            <ng-container *ngIf=" (actuatorsDivided$|async) as actuatorsDivided">
                                <ng-container *ngFor="let actuatorDivided of actuatorsDivided.divided; ">
                                    <mat-expansion-panel
                                            (opened)="openedExpansionPanel('actuators',actuatorDivided.title)"
                                            [expanded]="(lastAccordionActuatorsOpened$|async)===actuatorDivided.title"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="actuatorDivided.icon||actuatorDivided.svgIcon">
                                                    <ng-container *ngIf="actuatorDivided.icon; else SVGICON">
                                                        <mat-icon>{{ actuatorDivided.icon }}</mat-icon>
                                                    </ng-container>
                                                    <ng-template #SVGICON>
                                                        <mat-icon [svgIcon]="actuatorDivided?.svgIcon!"></mat-icon>
                                                    </ng-template>
                                                </ng-container>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                {{ actuatorDivided.title|translate }}
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-container *ngFor="let actuatorIndex of actuatorDivided.actuators; ">
                                            <div class="box-actuators">
                                                <app-box-actuators
                                                        (click)="clickBoxActuators(actuatorsDivided.all,actuatorIndex.indexAll)"
                                                        [actuator]="actuatorIndex.actuator"
                                                        [elements]="elements"
                                                        [lights]="lights"
                                                        [shutters]="shutters"
                                                        [switches]="switches"
                                                        [commands]="commands"
                                                        [linearActuators]="linearActuators"
                                                >
                                                    <div button
                                                         (click)="clickRemoveBoxActuators(actuatorsDivided.all,actuatorIndex.indexAll)">
                                                        <button mat-icon-button>
                                                            <mat-icon>cancel</mat-icon>
                                                        </button>
                                                    </div>
                                                </app-box-actuators>
                                                <mat-divider></mat-divider>
                                            </div>
                                        </ng-container>
                                    </mat-expansion-panel>
                                </ng-container>
                            </ng-container>
                        </mat-accordion>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div dx class="h100">
            <mat-card class="container-actuators margin-left-right-5px">
                <mat-card-header>
                    <mat-card-title>
                        {{ 'SensorEvent.infoElseActuators'|translate }}
                        <span class="text-color-accent">{{ 'SensorEvent.notVerified'|translate }}</span>
                    </mat-card-title>
                    <mat-card-subtitle>
                        <mat-error
                                *ngIf="errors!=null&&errors['else_actuators']">{{ ('errorsForm.' + errors['else_actuators'])|translate }}
                        </mat-error>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    @if (isEditable) {
                        <button style="margin: 5px 13px"
                                mat-raised-button color="primary" (click)="addElseActuators()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    }
                    <div class="flex-start-stretch flex-direction-row">
                        <mat-accordion class="width-panel" multi>
                            <ng-container *ngIf=" (elseActuatorsDivided$|async) as actuatorsDivided">
                                <ng-container *ngFor="let actuatorDivided of actuatorsDivided.divided; ">
                                    <mat-expansion-panel
                                            (opened)="openedExpansionPanel('actuators',actuatorDivided.title)"
                                            [expanded]="(lastAccordionActuatorsOpened$|async)===actuatorDivided.title"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="actuatorDivided.icon||actuatorDivided.svgIcon">
                                                    <ng-container *ngIf="actuatorDivided.icon; else SVGICON">
                                                        <mat-icon>{{ actuatorDivided.icon }}</mat-icon>
                                                    </ng-container>
                                                    <ng-template #SVGICON>
                                                        <mat-icon [svgIcon]="actuatorDivided?.svgIcon!"></mat-icon>
                                                    </ng-template>
                                                </ng-container>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                {{ actuatorDivided.title|translate }}
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <ng-container *ngFor="let actuatorIndex of actuatorDivided.actuators; ">
                                            <div class="box-actuators">
                                                <app-box-actuators
                                                        (click)="clickBoxElseActuators(actuatorsDivided.all,actuatorIndex.indexAll)"
                                                        [actuator]="actuatorIndex.actuator"
                                                        [elements]="elements"
                                                        [lights]="lights"
                                                        [shutters]="shutters"
                                                        [switches]="switches"
                                                        [commands]="commands"

                                                >
                                                    <div button
                                                         (click)="clickRemoveBoxElseActuators(actuatorsDivided.all,actuatorIndex.indexAll)">
                                                        <button mat-icon-button>
                                                            <mat-icon>cancel</mat-icon>
                                                        </button>
                                                    </div>
                                                </app-box-actuators>
                                                <mat-divider></mat-divider>
                                            </div>
                                        </ng-container>
                                    </mat-expansion-panel>
                                </ng-container>
                            </ng-container>
                        </mat-accordion>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </app-split-screen>
</ng-template>

<ng-template #ModifyStatement>
    <mat-dialog-content>
        <form [formGroup]="formSingleStatement">
            <app-field-statement-sensor-event [elements]="elements"
                                              [calendars]="calendars"
                                              [sensorDataType]=sensorDataType
                                              formControlName="newStatements"
                                              (statusChange)="statusChange($event)"
            >
            </app-field-statement-sensor-event>
        </form>
        <mat-error *ngIf="formSingleStatement.invalid">{{ 'allFieldsIsRequired'|translate }}</mat-error>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button color="accent"
                mat-flat-button
                matTooltip="{{'button.close' | translate}}" (click)="closeDialog()">
            <mat-icon>clear</mat-icon>
        </button>
        <button class="fab" color="primary" mat-flat-button
                [disabled]="formSingleStatement.invalid||!isEditable"
                matTooltip="{{'button.save' | translate}}" (click)="clickUpdateStatements()">
            <mat-icon>add</mat-icon>
        </button>
    </mat-dialog-actions>
</ng-template>
<ng-template #ModifyEnablingStatement>
    <mat-dialog-content>
        <form [formGroup]="formSingleStatement">
            <app-field-statement-sensor-event [elements]="elements"
                                              [calendars]="calendars"
                                              [sensorDataType]=sensorDataType
                                              formControlName="newStatements"
                                              (statusChange)="statusChange($event)"
            >
            </app-field-statement-sensor-event>
        </form>
        <mat-error *ngIf="formSingleStatement.invalid">{{ 'allFieldsIsRequired'|translate }}</mat-error>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button color="accent"
                mat-flat-button
                matTooltip="{{'button.close' | translate}}" (click)="closeDialog()">
            <mat-icon>clear</mat-icon>
        </button>
        <button class="fab" color="primary" mat-flat-button
                [disabled]="formSingleStatement.invalid||!isEditable"
                matTooltip="{{'button.save' | translate}}" (click)="clickUpdateStatements()">
            <mat-icon>add</mat-icon>
        </button>
    </mat-dialog-actions>
</ng-template>
<ng-template #ModifyActuators>
    <mat-dialog-content>
        <form [formGroup]="formSingleStatement">
            <app-form-field-actuators-sensor-event
                    [elements]="elements"
                    [lights]="lights"
                    [shutters]="shutters"
                    [switches]="switches"
                    [commands]="commands"
                    [linearActuators]="linearActuators"
                    [sensorDataTypes]="sensorDataType"
                    formControlName="newActuators"

                    (statusChange)="statusChange($event)"
            >
            </app-form-field-actuators-sensor-event>
        </form>
        <mat-error *ngIf="formSingleStatement.invalid">{{ 'allFieldsIsRequired'|translate }}</mat-error>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button color="accent"
                mat-flat-button
                matTooltip="{{'button.close' | translate}}"
                (click)="closeDialog()">
            <mat-icon>clear</mat-icon>
        </button>
        <button class="fab" color="primary"
                mat-flat-button
                [disabled]="formSingleStatement.invalid||!isEditable"
                matTooltip="{{'button.save' | translate}}" (click)="clickUpdateActuators()">
            <mat-icon>add</mat-icon>
        </button>

    </mat-dialog-actions>
</ng-template>

<mat-card style="max-height: calc(100vh - 30px) ;overflow-y: visible">
    <mat-card-content style="overflow-x: hidden">
        <ng-container [ngTemplateOutlet]="globalForm"
                      [ngTemplateOutletContext]="fieldsInErrors$|async">

        </ng-container>
    </mat-card-content>
    <mat-card-actions>
        <button color="accent" mat-flat-button
                matTooltip="{{'button.save' | translate}}"
                (click)="closeWithoutSave()"
        >
            <mat-icon>clear</mat-icon>
        </button>
        <ng-container>
            @if (isEditable) {
                <button color="primary" mat-flat-button
                        style="margin: 0 5px"
                        matTooltip="{{'button.save' | translate}}"
                        [disabled]="form.invalid"
                        (click)="clickSaveButton()">
                    <mat-icon>save</mat-icon>
                </button>
            }
        </ng-container>
    </mat-card-actions>
</mat-card>


